import i18n from "../../../../services/i18n";
import { useEffect, useState } from 'react'
import { Input, Select } from 'antd';
import { useMutation, useQuery } from '@tanstack/react-query';
import { GET_KPI_SETTING, UPDATE_KPI_SETTING } from '../../../../rest-api/queries/settingKPI';
import styles from './kpiSettingStyle.module.css'
import useQueryParams from '../../../../hooks/useQueryParams';
import { message } from "antd"




const KpiSettings = () => {

  const [activKpiTypes, setActiveKpiTypes] = useState<any>()
  const [kpiData, setKpiData] = useState<any>(null)
  const [selectedType, setSelectedType] = useState<any>()

  const { data, refetch } = useQuery(
    ["GET_KPI_SETTING", ],
      GET_KPI_SETTING,
  )
  
  useEffect(() => {
    if(data) {
      setActiveKpiTypes(data)
    }
  }, [data])

  const { mutate: updateInfo, isLoading: isUpdating } = useMutation(UPDATE_KPI_SETTING, {
    onSuccess: () => {
      message.success(String(i18n.t("kpiSaved")))
      refetch()
    },
    onError: (err: any) => {
      message.error(err?.response?.data?.message || String(err))
    },
  })

  const handleClick = () => {
    if (selectedType && kpiData !== "") {
      const _data = { ...data }
      _data[selectedType] = Number(kpiData)
      updateInfo(_data)
      setSelectedType(null)
      setKpiData("")
    } else {
      message.warning(i18n.t("msgEnterKpi"))
    }
  }

  const kpiValues = data || {
    cashKPI: 0,
    plasticKPI: 0,
    precheslinKPI: 0,
    debtKPI: 0,
  }

  const options = [
    {
      id: 1,
      name: String(i18n.t("colCash")),
      value: "cashKPI",
    },
    {
      id: 2,
      name: String(i18n.t("colCard")),
      value: "plasticKPI",
    },
    {
      id: 3,
      name: String(i18n.t("colTransfer")),
      value: "precheslinKPI",
    },
    {
      id: 4,
      name: String(i18n.t("onCredit")),
      value: "debtKPI",
    },
  ]

  return (
    <div style={{margin: '0'}}>
      <div className={styles.items}>
        {options.map((e) => (
          <div key={e.id} className={styles.item}>
            <p className={styles.item_text}>{e.name}</p>
            <div className={styles.item_kpi}>{kpiValues[e.value] ?? 0}</div>
          </div>
        ))}
      </div>
    <Input.Group compact>
      <Select 
      options={options?.map((option) => ({
        label: option.name,
        value: option.value,
      }))}
      style={{width: '50%'}}
      onChange={(val) => {setSelectedType(val)}}
      placeholder={String(i18n.t("chooseKpiType"))}
      value={ selectedType }
      >
      </Select>
      <Input
      required
      type='number' 
      onChange={(e) => setKpiData(e.target.value)}
      value={kpiData}
      placeholder={String(i18n.t("enterKpi"))} 
      style={{ width: '50%' }}/>
    </Input.Group>
      <button type='button' className={styles.button} onClick={handleClick} >
        {i18n.t("save")}
      </button>  
</div>
  )
}

export default KpiSettings